module.exports = __webpack_public_path__ + "assets/EWS.912d5dea.svg";